import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { fragmentMap } from '../../utils/ReactUtils.js';
import { getGridColumnClasses } from '../GridColumn/GridColumnPresentation.js';
import { IconLinkGroupWrapper } from '../IconLinkGroup/IconLinkGroupWrapper.js';
import { SpinnerPresentation } from '../Spinner/SpinnerPresentation.js';
import { getThemeChildrenClass } from '../Theme/ThemePresentation.js';
import { hostClass } from './CardsCustomItem.styles.js';
import { CardsMenu } from './CardsMenu.js';

var defaultProps = {
  look: "default"
};
var CardsCustomItemPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    children = props.children,
    className = props.className,
    noMargin = props.noMargin,
    contentBottom = props.contentBottom,
    contentTop = props.contentTop,
    pictureBottom = props.pictureBottom,
    pictureTop = props.pictureTop,
    itemsPerRow = props.itemsPerRow,
    hasMouseHover = props.hasMouseHover,
    hasKeyboardFocus = props.hasKeyboardFocus,
    isActive = props.isActive,
    centeredLayout = props.centeredLayout,
    spacing = props.spacing,
    menuCallbacks = props.menuCallbacks,
    menuNavigationTree = props.menuNavigationTree,
    onMenuMouseHoverChange = props.onMenuMouseHoverChange,
    onMenuKeyboardFocusChange = props.onMenuKeyboardFocusChange,
    hasMenuMouseHover = props.hasMenuMouseHover,
    hasMenuKeyboardFocus = props.hasMenuKeyboardFocus,
    disabled = props.disabled,
    loading = props.loading,
    look = props.look;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    role: "listitem",
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__shadow"), !disabled && !loading && look === "default"), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(look), look), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__hover"), hasMouseHover || hasKeyboardFocus), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__disabled"), disabled), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__loading"), loading), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__active"), isActive), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__active-dwindle"), isActive && look !== "placeholder"), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(spacing), spacing), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, getGridColumnClasses({
      size: 12 / itemsPerRow,
      sm: 4,
      xs: 4
    }), true), _defineProperty(_cleanupClassObject, getThemeChildrenClass("elevated"), true), _cleanupClassObject))
  }, loading && /*#__PURE__*/React.createElement(SpinnerPresentation, {
    variant: "indeterminate",
    expandToOverlay: true
  }), menuNavigationTree && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-menu")
  }, /*#__PURE__*/React.createElement(IconLinkGroupWrapper, null, /*#__PURE__*/React.createElement(CardsMenu, {
    disabled: disabled || loading,
    menuCallbacks: menuCallbacks,
    navigationTree: menuNavigationTree,
    onMouseHoverChange: onMenuMouseHoverChange,
    onKeyboardFocusChange: onMenuKeyboardFocusChange,
    hasMouseHover: hasMenuMouseHover,
    hasKeyboardFocus: hasMenuKeyboardFocus
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-inner")
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-inner-inner"), true))
  }, pictureTop && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "__picture-top")
  }, pictureTop), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-content")
  }, [contentTop, children, contentBottom].map(function (content) {
    return content && /*#__PURE__*/React.createElement("div", {
      className: "".concat(hostClass, "-content-block")
    }, centeredLayout ? fragmentMap(content, function (child) {
      return /*#__PURE__*/React.cloneElement(child, {
        horizontalAlignment: "center"
      });
    }) : content);
  })), pictureBottom && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "__picture-top")
  }, pictureBottom))));
}, defaultProps);
CardsCustomItemPresentation.displayName = "CardsCustomItemPresentation";

export { CardsCustomItemPresentation, defaultProps };
